import React from "react";
import AddDeliveryMan from "@commons/delivery-man-management/form";

import IndividualDelivery from "@commons/delivery-man-management/individual-delivery";
import DeliveryManList from "@commons/delivery-man-management/list";
import PendingDeliveryManRequest from "@commons/delivery-man-management/pending-requests";
import Cancelled from "@commons/orders/cancelled";
import Rejected from "@commons/orders/rejected";
import Delivered from "@commons/orders/delivered";
import Invoice from "@commons/orders/individual-order-details/invoice";
import OrderDetails from "@commons/orders/individual-order-details/order-details";
import PaymentFailed from "@commons/orders/payment-failed";
import StoreForm from "@commons/store-setup/form";
import IndividualStore from "@commons/store-setup/individual-store";
import ProductSetup from "@commons/store-setup/individual-store/product-setup";
import CreateProductForm from "@commons/store-setup/individual-store/product-setup/form/Main";
import StoreBannerSetup from "@pages/store/banner-settings";
import StoreSupportChat from "@pages/store/chat";
import StoreCouponSetup from "@pages/store/coupon-setup";
import StoreDashboard from "@pages/store/dashboard";
import StorePushNotification from "@pages/store/push-notifications";
import StoreDeals from "@pages/store/deals";
import StoreDealProducts from "@pages/store/deals/ManageProducts";

// Order status components (same as admin)
import OrderPlaced from "@commons/orders/order-placed";
import OrderConfirmed from "@commons/orders/order-confirmed";
import OrderProcessing from "@commons/orders/order-processing";
import DeliveryAssigned from "@commons/orders/delivery-assigned";
import ReadyForPickup from "@commons/orders/ready-for-pickup";
import OrderPickedUp from "@commons/orders/order-picked-up";
import OutForDelivery from "@commons/orders/out-for-delivery";
import NearCustomer from "@commons/orders/near-customer";
import PrescriptionRequested from "@commons/orders/prescription-requested";
import PrescriptionAccepted from "@commons/orders/prescription-accepted";
import CreatingInvoice from "@commons/orders/creating-invoice";
import InvoiceShared from "@commons/orders/invoice-shared";
import InvoiceAccepted from "@commons/orders/invoice-accepted";
import PrescriptionRejected from "@commons/orders/prescription-rejected";
import StoreWithdrawalsPage from "@pages/store/withdrawals";
import StoreDealsList from "@pages/store/deals";
import NotificationsPage from "@pages/notifications";
import BackgroundTasks from "@pages/admin/product-management/products/background-tasks";
import StoreSubAdmins from "@pages/store/employee";
import CreateEmployee from "@pages/store/employee/CreateEmployee";
import StoreRolesPage from "@pages/store/roles";
import CreateStoreRole from "@pages/store/roles/CreateRole";
import StoreReviewsPage from "@pages/store/reviews";

export const storeRoutes = [
  // Team Management
  {
    path: "users/sub-admins",
    Component: StoreSubAdmins,
    exact: true,
  },
  {
    path: "users/sub-admins/create",
    Component: CreateEmployee,
    exact: true,
  },
  {
    path: "users/sub-admins/edit/:id",
    Component: CreateEmployee,
    exact: true,
  },
  {
    path: "roles",
    Component: StoreRolesPage,
    exact: true,
  },
  {
    path: "roles/create",
    Component: CreateStoreRole,
    exact: true,
  },
  {
    path: "roles/edit/:id",
    Component: CreateStoreRole,
    exact: true,
  },
  {
    path: "transaction/withdraw-request",
    Component: StoreWithdrawalsPage,
    exact: true,
  },
  {
    path: "transaction/my-wallet",
    Component: React.lazy(() => import("@pages/store/wallet")),
    exact: true,
  },
  { path: "deals", Component: StoreDealsList, exact: true },

  { path: "deals/:id/products", Component: StoreDealProducts, exact: true },
  { path: "dashboard", Component: StoreDashboard, exact: true },
  { path: "reviews", Component: StoreReviewsPage, exact: true },
  { path: "chat", Component: StoreSupportChat, exact: true },
  { path: "chat/:params", Component: StoreSupportChat, exact: true },
  { path: "notifications", Component: NotificationsPage, exact: true },

  // Order status routes (matching admin panel)
  {
    path: "orders/order-placed",
    Component: OrderPlaced,
    exact: true,
  },
  {
    path: "orders/order-confirmed",
    Component: OrderConfirmed,
    exact: true,
  },
  {
    path: "orders/order-processing",
    Component: OrderProcessing,
    exact: true,
  },
  {
    path: "orders/delivery-assigned",
    Component: DeliveryAssigned,
    exact: true,
  },
  {
    path: "orders/ready-for-pickup",
    Component: ReadyForPickup,
    exact: true,
  },
  {
    path: "orders/order-picked-up",
    Component: OrderPickedUp,
    exact: true,
  },
  {
    path: "orders/out-for-delivery",
    Component: OutForDelivery,
    exact: true,
  },
  {
    path: "orders/near-customer",
    Component: NearCustomer,
    exact: true,
  },
  {
    path: "orders/delivered",
    Component: Delivered,
    exact: true,
  },
  {
    path: "orders/prescription-requested",
    Component: PrescriptionRequested,
    exact: true,
  },
  {
    path: "orders/prescription-accepted",
    Component: PrescriptionAccepted,
    exact: true,
  },
  {
    path: "orders/creating-invoice",
    Component: CreatingInvoice,
    exact: true,
  },
  {
    path: "orders/invoice-shared",
    Component: InvoiceShared,
    exact: true,
  },
  {
    path: "orders/invoice-accepted",
    Component: InvoiceAccepted,
    exact: true,
  },
  {
    path: "orders/prescription-rejected",
    Component: PrescriptionRejected,
    exact: true,
  },
  {
    path: "orders/cancelled",
    Component: Cancelled,
    exact: true,
  },
  {
    path: "orders/rejected",
    Component: Rejected,
    exact: true,
  },
  {
    path: "orders/payment-failed",
    Component: PaymentFailed,
    exact: true,
  },
  {
    path: "orders/details/:id",
    Component: OrderDetails,
    exact: true,
  },
  {
    path: "orders/invoice/:id",
    Component: Invoice,
    exact: true,
  },
  {
    path: "banner-settings",
    Component: StoreBannerSetup,
    exact: true,
  },
  {
    path: "banner-settings/:id",
    Component: StoreBannerSetup,
    exact: true,
  },
  {
    path: "coupon-setup",
    Component: StoreCouponSetup,
    exact: true,
  },
  {
    path: "coupon-setup/:id",
    Component: StoreCouponSetup,
    exact: true,
  },
  {
    path: "push-notifications",
    Component: StorePushNotification,
    exact: true,
  },
  {
    path: "view",
    Component: IndividualStore,
    exact: true,
  },
  {
    path: "users/update-store/:id",
    Component: StoreForm,
    exact: true,
  },
  {
    path: "product-management/add-product",
    Component: CreateProductForm,
    exact: true,
  },
  {
    path: "product-management/update-product/:id",
    Component: CreateProductForm,
    exact: true,
  },
  {
    path: "product-management/view-product/:id",
    Component: CreateProductForm,
    exact: true,
  },
  {
    path: "product-management/products",
    Component: ProductSetup,
    exact: true,
  },
  {
    path: "product-management/products/background-tasks",
    Component: BackgroundTasks,
    exact: true,
  },
  {
    path: "product-management/categories",
    Component: React.lazy(() => import("@pages/store/categories")),
    exact: true,
  },
  {
    path: "product-management/categories/edit/:id",
    Component: React.lazy(() => import("@pages/store/categories/form")),
    exact: true,
  },
  {
    path: "pos",
    Component: React.lazy(() => import("@pages/store/pos-sale")),
    exact: true,
  },
  {
    path: "pos/:orderId",
    Component: React.lazy(() => import("@pages/store/pos")),
    exact: true,
  },
  {
    path: "pos-sale",
    Component: React.lazy(() => import("@pages/store/pos-sale")),
    exact: true,
  },
];
